import { get } from "core/api";
export default async function InternetTest(element) {
  element.setStateIcon("busy");
  element.setStateText("Teste ...");
  return new Promise(async (res, rej) => {
    try {
      const {
        success,
        payload = null,
        details = null
      } = await get("/ping");
      if (success) {
        element.setStateIcon("ok");
        element.setStateText(payload.message);
        res(true);
      } else {
        element.setStateIcon("error");
        element.setStateText(details);
        res(false);
      }
    } catch (err) {
      element.setStateText(err);
      element.setStateIcon("error");
      res(false);
    }
  });
}